/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type WarningContainer_viewer = {
    readonly status: {
        readonly warning: {
            readonly active: boolean;
            readonly message: string | null;
        };
    };
    readonly " $refType": "WarningContainer_viewer";
};
export type WarningContainer_viewer$data = WarningContainer_viewer;
export type WarningContainer_viewer$key = {
    readonly " $data"?: WarningContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"WarningContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WarningContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "WarningStatus",
                    "kind": "LinkedField",
                    "name": "warning",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = 'bd9538d774d443d0440efe10f812adc9';
export default node;
